import { useAuthState } from 'shared/stores';

export function useUserRoles() {
    const authState = useAuthState();
    const currentUser = authState.user.get();
    const currentUserEmailAddress = currentUser?.email! || '';
    const isInternalUser = currentUserEmailAddress.includes('@insight2profit.com');

    return {
        isInternalUser
    };
}
